/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SolutionEngineerRouteImport } from './routes/solution-engineer'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as LoginRouteImport } from './routes/login'
import { Route as KbConfigRouteImport } from './routes/kb-config'
import { Route as ItsmImportRouteImport } from './routes/itsm-import'
import { Route as ItsmConfigRouteImport } from './routes/itsm-config'
import { Route as IntentsRouteImport } from './routes/intents'
import { Route as IntentHubRouteImport } from './routes/intent-hub'
import { Route as IntegrationsRouteImport } from './routes/integrations'
import { Route as HelpRouteImport } from './routes/help'
import { Route as HealthRouteImport } from './routes/health'
import { Route as DeskSuggestionsRouteImport } from './routes/desk-suggestions'
import { Route as DeskMigrationRouteImport } from './routes/desk-migration'
import { Route as DeskImprovementsRouteImport } from './routes/desk-improvements'
import { Route as CellSignInRouteImport } from './routes/cell-sign-in'
import { Route as BroadcastRouteImport } from './routes/broadcast'
import { Route as BillingRouteImport } from './routes/billing'
import { Route as AccessKeysRouteImport } from './routes/access-keys'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TenantsIndexRouteImport } from './routes/tenants/index'
import { Route as TenantsTenantIdRouteImport } from './routes/tenants/$tenantId'
import { Route as ItsmImportNewRouteImport } from './routes/itsm-import_.new'
import { Route as ItsmImportJobIdRouteImport } from './routes/itsm-import_.$jobId'
import { Route as AgentAnalyticsRouteImport } from './routes/agent/analytics'
import { Route as AgentAiDeflectionMapRouteImport } from './routes/agent/ai-deflection-map'
import { Route as AgentKbInsightsIndexRouteImport } from './routes/agent/kb-insights/index'
import { Route as AgentConversationsIndexRouteImport } from './routes/agent/conversations/index'
import { Route as AgentKbInsightsRecIdRouteImport } from './routes/agent/kb-insights/$recId'
import { Route as AgentConversationsThreadThreadIdRouteImport } from './routes/agent/conversations/thread/$threadId'
import { Route as AgentConversationsTenantIdConversationIdRouteImport } from './routes/agent/conversations/$tenantId/$conversationId'

const SolutionEngineerRoute = SolutionEngineerRouteImport.update({
  id: '/solution-engineer',
  path: '/solution-engineer',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const KbConfigRoute = KbConfigRouteImport.update({
  id: '/kb-config',
  path: '/kb-config',
  getParentRoute: () => rootRouteImport,
} as any)
const ItsmImportRoute = ItsmImportRouteImport.update({
  id: '/itsm-import',
  path: '/itsm-import',
  getParentRoute: () => rootRouteImport,
} as any)
const ItsmConfigRoute = ItsmConfigRouteImport.update({
  id: '/itsm-config',
  path: '/itsm-config',
  getParentRoute: () => rootRouteImport,
} as any)
const IntentsRoute = IntentsRouteImport.update({
  id: '/intents',
  path: '/intents',
  getParentRoute: () => rootRouteImport,
} as any)
const IntentHubRoute = IntentHubRouteImport.update({
  id: '/intent-hub',
  path: '/intent-hub',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsRoute = IntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpRoute = HelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRouteImport,
} as any)
const HealthRoute = HealthRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => rootRouteImport,
} as any)
const DeskSuggestionsRoute = DeskSuggestionsRouteImport.update({
  id: '/desk-suggestions',
  path: '/desk-suggestions',
  getParentRoute: () => rootRouteImport,
} as any)
const DeskMigrationRoute = DeskMigrationRouteImport.update({
  id: '/desk-migration',
  path: '/desk-migration',
  getParentRoute: () => rootRouteImport,
} as any)
const DeskImprovementsRoute = DeskImprovementsRouteImport.update({
  id: '/desk-improvements',
  path: '/desk-improvements',
  getParentRoute: () => rootRouteImport,
} as any)
const CellSignInRoute = CellSignInRouteImport.update({
  id: '/cell-sign-in',
  path: '/cell-sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const BroadcastRoute = BroadcastRouteImport.update({
  id: '/broadcast',
  path: '/broadcast',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingRoute = BillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessKeysRoute = AccessKeysRouteImport.update({
  id: '/access-keys',
  path: '/access-keys',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantsIndexRoute = TenantsIndexRouteImport.update({
  id: '/tenants/',
  path: '/tenants/',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantsTenantIdRoute = TenantsTenantIdRouteImport.update({
  id: '/tenants/$tenantId',
  path: '/tenants/$tenantId',
  getParentRoute: () => rootRouteImport,
} as any)
const ItsmImportNewRoute = ItsmImportNewRouteImport.update({
  id: '/itsm-import_/new',
  path: '/itsm-import/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ItsmImportJobIdRoute = ItsmImportJobIdRouteImport.update({
  id: '/itsm-import_/$jobId',
  path: '/itsm-import/$jobId',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentAnalyticsRoute = AgentAnalyticsRouteImport.update({
  id: '/agent/analytics',
  path: '/agent/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentAiDeflectionMapRoute = AgentAiDeflectionMapRouteImport.update({
  id: '/agent/ai-deflection-map',
  path: '/agent/ai-deflection-map',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentKbInsightsIndexRoute = AgentKbInsightsIndexRouteImport.update({
  id: '/agent/kb-insights/',
  path: '/agent/kb-insights/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentConversationsIndexRoute = AgentConversationsIndexRouteImport.update({
  id: '/agent/conversations/',
  path: '/agent/conversations/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentKbInsightsRecIdRoute = AgentKbInsightsRecIdRouteImport.update({
  id: '/agent/kb-insights/$recId',
  path: '/agent/kb-insights/$recId',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentConversationsThreadThreadIdRoute =
  AgentConversationsThreadThreadIdRouteImport.update({
    id: '/agent/conversations/thread/$threadId',
    path: '/agent/conversations/thread/$threadId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AgentConversationsTenantIdConversationIdRoute =
  AgentConversationsTenantIdConversationIdRouteImport.update({
    id: '/agent/conversations/$tenantId/$conversationId',
    path: '/agent/conversations/$tenantId/$conversationId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/access-keys': typeof AccessKeysRoute
  '/billing': typeof BillingRoute
  '/broadcast': typeof BroadcastRoute
  '/cell-sign-in': typeof CellSignInRoute
  '/desk-improvements': typeof DeskImprovementsRoute
  '/desk-migration': typeof DeskMigrationRoute
  '/desk-suggestions': typeof DeskSuggestionsRoute
  '/health': typeof HealthRoute
  '/help': typeof HelpRoute
  '/integrations': typeof IntegrationsRoute
  '/intent-hub': typeof IntentHubRoute
  '/intents': typeof IntentsRoute
  '/itsm-config': typeof ItsmConfigRoute
  '/itsm-import': typeof ItsmImportRoute
  '/kb-config': typeof KbConfigRoute
  '/login': typeof LoginRoute
  '/settings': typeof SettingsRoute
  '/solution-engineer': typeof SolutionEngineerRoute
  '/agent/ai-deflection-map': typeof AgentAiDeflectionMapRoute
  '/agent/analytics': typeof AgentAnalyticsRoute
  '/itsm-import/$jobId': typeof ItsmImportJobIdRoute
  '/itsm-import/new': typeof ItsmImportNewRoute
  '/tenants/$tenantId': typeof TenantsTenantIdRoute
  '/tenants': typeof TenantsIndexRoute
  '/agent/kb-insights/$recId': typeof AgentKbInsightsRecIdRoute
  '/agent/conversations': typeof AgentConversationsIndexRoute
  '/agent/kb-insights': typeof AgentKbInsightsIndexRoute
  '/agent/conversations/$tenantId/$conversationId': typeof AgentConversationsTenantIdConversationIdRoute
  '/agent/conversations/thread/$threadId': typeof AgentConversationsThreadThreadIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/access-keys': typeof AccessKeysRoute
  '/billing': typeof BillingRoute
  '/broadcast': typeof BroadcastRoute
  '/cell-sign-in': typeof CellSignInRoute
  '/desk-improvements': typeof DeskImprovementsRoute
  '/desk-migration': typeof DeskMigrationRoute
  '/desk-suggestions': typeof DeskSuggestionsRoute
  '/health': typeof HealthRoute
  '/help': typeof HelpRoute
  '/integrations': typeof IntegrationsRoute
  '/intent-hub': typeof IntentHubRoute
  '/intents': typeof IntentsRoute
  '/itsm-config': typeof ItsmConfigRoute
  '/itsm-import': typeof ItsmImportRoute
  '/kb-config': typeof KbConfigRoute
  '/login': typeof LoginRoute
  '/settings': typeof SettingsRoute
  '/solution-engineer': typeof SolutionEngineerRoute
  '/agent/ai-deflection-map': typeof AgentAiDeflectionMapRoute
  '/agent/analytics': typeof AgentAnalyticsRoute
  '/itsm-import/$jobId': typeof ItsmImportJobIdRoute
  '/itsm-import/new': typeof ItsmImportNewRoute
  '/tenants/$tenantId': typeof TenantsTenantIdRoute
  '/tenants': typeof TenantsIndexRoute
  '/agent/kb-insights/$recId': typeof AgentKbInsightsRecIdRoute
  '/agent/conversations': typeof AgentConversationsIndexRoute
  '/agent/kb-insights': typeof AgentKbInsightsIndexRoute
  '/agent/conversations/$tenantId/$conversationId': typeof AgentConversationsTenantIdConversationIdRoute
  '/agent/conversations/thread/$threadId': typeof AgentConversationsThreadThreadIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/access-keys': typeof AccessKeysRoute
  '/billing': typeof BillingRoute
  '/broadcast': typeof BroadcastRoute
  '/cell-sign-in': typeof CellSignInRoute
  '/desk-improvements': typeof DeskImprovementsRoute
  '/desk-migration': typeof DeskMigrationRoute
  '/desk-suggestions': typeof DeskSuggestionsRoute
  '/health': typeof HealthRoute
  '/help': typeof HelpRoute
  '/integrations': typeof IntegrationsRoute
  '/intent-hub': typeof IntentHubRoute
  '/intents': typeof IntentsRoute
  '/itsm-config': typeof ItsmConfigRoute
  '/itsm-import': typeof ItsmImportRoute
  '/kb-config': typeof KbConfigRoute
  '/login': typeof LoginRoute
  '/settings': typeof SettingsRoute
  '/solution-engineer': typeof SolutionEngineerRoute
  '/agent/ai-deflection-map': typeof AgentAiDeflectionMapRoute
  '/agent/analytics': typeof AgentAnalyticsRoute
  '/itsm-import_/$jobId': typeof ItsmImportJobIdRoute
  '/itsm-import_/new': typeof ItsmImportNewRoute
  '/tenants/$tenantId': typeof TenantsTenantIdRoute
  '/tenants/': typeof TenantsIndexRoute
  '/agent/kb-insights/$recId': typeof AgentKbInsightsRecIdRoute
  '/agent/conversations/': typeof AgentConversationsIndexRoute
  '/agent/kb-insights/': typeof AgentKbInsightsIndexRoute
  '/agent/conversations/$tenantId/$conversationId': typeof AgentConversationsTenantIdConversationIdRoute
  '/agent/conversations/thread/$threadId': typeof AgentConversationsThreadThreadIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/access-keys'
    | '/billing'
    | '/broadcast'
    | '/cell-sign-in'
    | '/desk-improvements'
    | '/desk-migration'
    | '/desk-suggestions'
    | '/health'
    | '/help'
    | '/integrations'
    | '/intent-hub'
    | '/intents'
    | '/itsm-config'
    | '/itsm-import'
    | '/kb-config'
    | '/login'
    | '/settings'
    | '/solution-engineer'
    | '/agent/ai-deflection-map'
    | '/agent/analytics'
    | '/itsm-import/$jobId'
    | '/itsm-import/new'
    | '/tenants/$tenantId'
    | '/tenants'
    | '/agent/kb-insights/$recId'
    | '/agent/conversations'
    | '/agent/kb-insights'
    | '/agent/conversations/$tenantId/$conversationId'
    | '/agent/conversations/thread/$threadId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/access-keys'
    | '/billing'
    | '/broadcast'
    | '/cell-sign-in'
    | '/desk-improvements'
    | '/desk-migration'
    | '/desk-suggestions'
    | '/health'
    | '/help'
    | '/integrations'
    | '/intent-hub'
    | '/intents'
    | '/itsm-config'
    | '/itsm-import'
    | '/kb-config'
    | '/login'
    | '/settings'
    | '/solution-engineer'
    | '/agent/ai-deflection-map'
    | '/agent/analytics'
    | '/itsm-import/$jobId'
    | '/itsm-import/new'
    | '/tenants/$tenantId'
    | '/tenants'
    | '/agent/kb-insights/$recId'
    | '/agent/conversations'
    | '/agent/kb-insights'
    | '/agent/conversations/$tenantId/$conversationId'
    | '/agent/conversations/thread/$threadId'
  id:
    | '__root__'
    | '/'
    | '/access-keys'
    | '/billing'
    | '/broadcast'
    | '/cell-sign-in'
    | '/desk-improvements'
    | '/desk-migration'
    | '/desk-suggestions'
    | '/health'
    | '/help'
    | '/integrations'
    | '/intent-hub'
    | '/intents'
    | '/itsm-config'
    | '/itsm-import'
    | '/kb-config'
    | '/login'
    | '/settings'
    | '/solution-engineer'
    | '/agent/ai-deflection-map'
    | '/agent/analytics'
    | '/itsm-import_/$jobId'
    | '/itsm-import_/new'
    | '/tenants/$tenantId'
    | '/tenants/'
    | '/agent/kb-insights/$recId'
    | '/agent/conversations/'
    | '/agent/kb-insights/'
    | '/agent/conversations/$tenantId/$conversationId'
    | '/agent/conversations/thread/$threadId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccessKeysRoute: typeof AccessKeysRoute
  BillingRoute: typeof BillingRoute
  BroadcastRoute: typeof BroadcastRoute
  CellSignInRoute: typeof CellSignInRoute
  DeskImprovementsRoute: typeof DeskImprovementsRoute
  DeskMigrationRoute: typeof DeskMigrationRoute
  DeskSuggestionsRoute: typeof DeskSuggestionsRoute
  HealthRoute: typeof HealthRoute
  HelpRoute: typeof HelpRoute
  IntegrationsRoute: typeof IntegrationsRoute
  IntentHubRoute: typeof IntentHubRoute
  IntentsRoute: typeof IntentsRoute
  ItsmConfigRoute: typeof ItsmConfigRoute
  ItsmImportRoute: typeof ItsmImportRoute
  KbConfigRoute: typeof KbConfigRoute
  LoginRoute: typeof LoginRoute
  SettingsRoute: typeof SettingsRoute
  SolutionEngineerRoute: typeof SolutionEngineerRoute
  AgentAiDeflectionMapRoute: typeof AgentAiDeflectionMapRoute
  AgentAnalyticsRoute: typeof AgentAnalyticsRoute
  ItsmImportJobIdRoute: typeof ItsmImportJobIdRoute
  ItsmImportNewRoute: typeof ItsmImportNewRoute
  TenantsTenantIdRoute: typeof TenantsTenantIdRoute
  TenantsIndexRoute: typeof TenantsIndexRoute
  AgentKbInsightsRecIdRoute: typeof AgentKbInsightsRecIdRoute
  AgentConversationsIndexRoute: typeof AgentConversationsIndexRoute
  AgentKbInsightsIndexRoute: typeof AgentKbInsightsIndexRoute
  AgentConversationsTenantIdConversationIdRoute: typeof AgentConversationsTenantIdConversationIdRoute
  AgentConversationsThreadThreadIdRoute: typeof AgentConversationsThreadThreadIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/solution-engineer': {
      id: '/solution-engineer'
      path: '/solution-engineer'
      fullPath: '/solution-engineer'
      preLoaderRoute: typeof SolutionEngineerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kb-config': {
      id: '/kb-config'
      path: '/kb-config'
      fullPath: '/kb-config'
      preLoaderRoute: typeof KbConfigRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/itsm-import': {
      id: '/itsm-import'
      path: '/itsm-import'
      fullPath: '/itsm-import'
      preLoaderRoute: typeof ItsmImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/itsm-config': {
      id: '/itsm-config'
      path: '/itsm-config'
      fullPath: '/itsm-config'
      preLoaderRoute: typeof ItsmConfigRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/intents': {
      id: '/intents'
      path: '/intents'
      fullPath: '/intents'
      preLoaderRoute: typeof IntentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/intent-hub': {
      id: '/intent-hub'
      path: '/intent-hub'
      fullPath: '/intent-hub'
      preLoaderRoute: typeof IntentHubRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations': {
      id: '/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof IntegrationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help': {
      id: '/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof HelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/health': {
      id: '/health'
      path: '/health'
      fullPath: '/health'
      preLoaderRoute: typeof HealthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/desk-suggestions': {
      id: '/desk-suggestions'
      path: '/desk-suggestions'
      fullPath: '/desk-suggestions'
      preLoaderRoute: typeof DeskSuggestionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/desk-migration': {
      id: '/desk-migration'
      path: '/desk-migration'
      fullPath: '/desk-migration'
      preLoaderRoute: typeof DeskMigrationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/desk-improvements': {
      id: '/desk-improvements'
      path: '/desk-improvements'
      fullPath: '/desk-improvements'
      preLoaderRoute: typeof DeskImprovementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cell-sign-in': {
      id: '/cell-sign-in'
      path: '/cell-sign-in'
      fullPath: '/cell-sign-in'
      preLoaderRoute: typeof CellSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/broadcast': {
      id: '/broadcast'
      path: '/broadcast'
      fullPath: '/broadcast'
      preLoaderRoute: typeof BroadcastRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing': {
      id: '/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof BillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/access-keys': {
      id: '/access-keys'
      path: '/access-keys'
      fullPath: '/access-keys'
      preLoaderRoute: typeof AccessKeysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenants/': {
      id: '/tenants/'
      path: '/tenants'
      fullPath: '/tenants'
      preLoaderRoute: typeof TenantsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenants/$tenantId': {
      id: '/tenants/$tenantId'
      path: '/tenants/$tenantId'
      fullPath: '/tenants/$tenantId'
      preLoaderRoute: typeof TenantsTenantIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/itsm-import_/new': {
      id: '/itsm-import_/new'
      path: '/itsm-import/new'
      fullPath: '/itsm-import/new'
      preLoaderRoute: typeof ItsmImportNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/itsm-import_/$jobId': {
      id: '/itsm-import_/$jobId'
      path: '/itsm-import/$jobId'
      fullPath: '/itsm-import/$jobId'
      preLoaderRoute: typeof ItsmImportJobIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent/analytics': {
      id: '/agent/analytics'
      path: '/agent/analytics'
      fullPath: '/agent/analytics'
      preLoaderRoute: typeof AgentAnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent/ai-deflection-map': {
      id: '/agent/ai-deflection-map'
      path: '/agent/ai-deflection-map'
      fullPath: '/agent/ai-deflection-map'
      preLoaderRoute: typeof AgentAiDeflectionMapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent/kb-insights/': {
      id: '/agent/kb-insights/'
      path: '/agent/kb-insights'
      fullPath: '/agent/kb-insights'
      preLoaderRoute: typeof AgentKbInsightsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent/conversations/': {
      id: '/agent/conversations/'
      path: '/agent/conversations'
      fullPath: '/agent/conversations'
      preLoaderRoute: typeof AgentConversationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent/kb-insights/$recId': {
      id: '/agent/kb-insights/$recId'
      path: '/agent/kb-insights/$recId'
      fullPath: '/agent/kb-insights/$recId'
      preLoaderRoute: typeof AgentKbInsightsRecIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent/conversations/thread/$threadId': {
      id: '/agent/conversations/thread/$threadId'
      path: '/agent/conversations/thread/$threadId'
      fullPath: '/agent/conversations/thread/$threadId'
      preLoaderRoute: typeof AgentConversationsThreadThreadIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent/conversations/$tenantId/$conversationId': {
      id: '/agent/conversations/$tenantId/$conversationId'
      path: '/agent/conversations/$tenantId/$conversationId'
      fullPath: '/agent/conversations/$tenantId/$conversationId'
      preLoaderRoute: typeof AgentConversationsTenantIdConversationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccessKeysRoute: AccessKeysRoute,
  BillingRoute: BillingRoute,
  BroadcastRoute: BroadcastRoute,
  CellSignInRoute: CellSignInRoute,
  DeskImprovementsRoute: DeskImprovementsRoute,
  DeskMigrationRoute: DeskMigrationRoute,
  DeskSuggestionsRoute: DeskSuggestionsRoute,
  HealthRoute: HealthRoute,
  HelpRoute: HelpRoute,
  IntegrationsRoute: IntegrationsRoute,
  IntentHubRoute: IntentHubRoute,
  IntentsRoute: IntentsRoute,
  ItsmConfigRoute: ItsmConfigRoute,
  ItsmImportRoute: ItsmImportRoute,
  KbConfigRoute: KbConfigRoute,
  LoginRoute: LoginRoute,
  SettingsRoute: SettingsRoute,
  SolutionEngineerRoute: SolutionEngineerRoute,
  AgentAiDeflectionMapRoute: AgentAiDeflectionMapRoute,
  AgentAnalyticsRoute: AgentAnalyticsRoute,
  ItsmImportJobIdRoute: ItsmImportJobIdRoute,
  ItsmImportNewRoute: ItsmImportNewRoute,
  TenantsTenantIdRoute: TenantsTenantIdRoute,
  TenantsIndexRoute: TenantsIndexRoute,
  AgentKbInsightsRecIdRoute: AgentKbInsightsRecIdRoute,
  AgentConversationsIndexRoute: AgentConversationsIndexRoute,
  AgentKbInsightsIndexRoute: AgentKbInsightsIndexRoute,
  AgentConversationsTenantIdConversationIdRoute:
    AgentConversationsTenantIdConversationIdRoute,
  AgentConversationsThreadThreadIdRoute: AgentConversationsThreadThreadIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
